var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-5"},[_c('div',{staticClass:"Title text-h2 mt-15 text-center"},[_vm._v(" 404 Not Found "),_c('p',{staticClass:"text-h6 my-3"},[_vm._v("このページは存在しません。")])])])}
var staticRenderFns = []

export { render, staticRenderFns }